import { render, staticRenderFns } from "./WithdrawaltoBank.vue?vue&type=template&id=4346080c&"
import script from "./WithdrawaltoBank.vue?vue&type=script&lang=js&"
export * from "./WithdrawaltoBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports